<script>
import moment from 'moment'
import rules from './update-transaction-status-rules'
import { serviceColors, statusColors, service, status } from "../../../config/transaction"

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    serviceColors,
    statusColors,
  },
  data: () => ({
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
    service,
    status,
    rules,
    submitting: false,
    prodType: 0,
    showReconTime: true,
    form: {
      status: null,
      reconcile_time: null,
      response: {
        additional_data: {},
        bills: [
          {
            additional_data: {}
          }
        ]
      },
    }
  }),
  created() {
    if (['bpjs', 'multifinance', 'telkom', 'pulsa', 'emoney'].includes(this.item.product.group.name.toLowerCase()) == false) {
      if(this.item.response.additional_data instanceof Array) {
        delete this.item.response['additional_data'];
        this.item.response.additional_data = {}
      }
      this.form.response = this.item.response
    }
  },
  methods: {
    clear() {
      this.editModal = {
        submitting: false,
        item: {},
        form: {
          status: '',
          reconcile_time: '',
          response: {
            additional_data: {},
            bills: [
              {
                additional_data: {}
              }
            ]
          }
        }
      }
    },
    handleSuccessResponse(data) {
      if (data.status) {
        this.$notification.success({
          message: "Success",
          description: "Transaction data has been successfully updated!.",
          onClose: () => window.location.reload()
        })
      }
    },
    reset() {
      this.$refs.updateTransaction.resetFields()
      this.clear()
    },
    submit() {
      this.$refs.updateTransaction.validate(valid => {
        if (valid) {
          if(this.item.response.additional_data instanceof Array) {
            delete this.item.response['additional_data'];
          }

          this.form.response = _.merge(this.item.response, this.form.response)
          this.form.response.subscriber_phone = '-'
          this.form.response.subscriber_address = '-'

          if(this.prodType == 2){
            this.form.response.additional_data.unsold_token = []
          }

          this.submitting = true
          this.$http.patch(this.routeUri('hyperion.transaction.status.update', {
            transaction_uuid: this.item.id
          }), this.form)
            .then(res => this.handleSuccessResponse(res.data)).catch(err => this.handleXhrError(err))
            .finally(() => {
              this.submitting = false
              this.clear()
            })
        } else {
          return false
        }
      })
    },
    addBill() {
      this.form.response.bills.push({
        period: '',
        amount: 0,
        admin_charges: 0,
        additional_data: {
          vat: 0,
          current_meter_reading_1: 0,
          current_meter_reading_2: 0,
          current_meter_reading_3: 0,
          due_date: '',
          incentive: 0,
          meter_reading_date: '',
          penalty_fee: 0,
          prev_meter_reading_1: 0,
          prev_meter_reading_2: 0,
          prev_meter_reading_3: 0
        }
      })
    },
    onChangeReconcile(value, dateString) {
      this.form.reconcile_time = dateString
    },
  },
  watch: {
    'form.status': function (value) {
      if (value === status.TRANSACTION_STATUS_SUCCESS) {
        this.showReconTime = true
        this.form.reconcile_time = moment(this.item.created_at).utcOffset(7).format('YYYY-MM-DD HH:mm:ss')
        this.rules.response = [
          {required: true, message: 'Please fill the biller response.'}
        ]
      } else {
        this.showReconTime = false
        this.rules.response = []
      }
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small" :bordered="false">
    <a-divider dashed>Transaction</a-divider>

    <a-descriptions size="small">
      <a-descriptions-item label="Client">
        <p>{{ item.client.name }}</p>
      </a-descriptions-item>
      <a-descriptions-item label="Product">
        <p><code>{{ item.product.name }}</code></p>
      </a-descriptions-item>
      <a-descriptions-item label="Subscriber ID">
        <p><code>{{ item.subscriber_id }}</code></p>
      </a-descriptions-item>
      <a-descriptions-item label="Current Status">
        <p :style="{ color: statusColors[item.status] }"><code>{{ item.status.toUpperCase() }}</code></p>
      </a-descriptions-item>
      <a-descriptions-item label="Transaction At">
        <p><code>{{ moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') }}</code></p>
      </a-descriptions-item>
    </a-descriptions>

    <a-divider dashed>Update Information</a-divider>

    <a-form-model style="margin-top: 16px" :colon="false" :model="form" :rules="rules" ref="updateTransaction" labelAlign="left" :labelCol="labelCol" :wrapperCol="wrapperCol">

      <a-form-model-item label="New Transaction Status" prop="status">
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button :value="status.TRANSACTION_STATUS_SUCCESS">
            {{ status.TRANSACTION_STATUS_SUCCESS.toUpperCase() }}
          </a-radio-button>

          <a-radio-button :value="status.TRANSACTION_STATUS_FAILED">
            {{ status.TRANSACTION_STATUS_FAILED.toUpperCase() }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="Reconcile Time" prop="reconcile_time" v-if="showReconTime">
        <a-date-picker show-time placeholder="Select Time" @change="onChangeReconcile" :defaultValue="moment(item.created_at).utcOffset(7).format('YYYY-MM-DD HH:mm:ss')" v-model="form.reconcile_time"/>
      </a-form-model-item>

      <a-divider dashed>Biller Response</a-divider>

      <template v-if="item.product.group.name.toLowerCase() === 'pln'">
        <a-form-model-item label="Subscriber ID" prop="subscriber_id">
          <a-input placeholder="Subscriber ID." v-model="form.response.subscriber_id"></a-input>
        </a-form-model-item>

        <a-form-model-item label="Alternate ID" prop="alternate_id">
          <a-input placeholder="Alternate ID." v-model="form.response.alternate_id"></a-input>
        </a-form-model-item>

        <a-form-model-item label="Subscriber Name" prop="subscriber_name">
          <a-input placeholder="Subscriber Name." v-model="form.response.subscriber_name"></a-input>
        </a-form-model-item>

        <a-form-model-item label="Ref ID" prop="ref_id">
          <a-input placeholder="Ref ID." v-model="form.response.ref_id"></a-input>
        </a-form-model-item>

        <a-form-model-item label="Bill Amount" prop="amount">
          <a-input placeholder="Bill Amount." v-model.number="form.response.amount"></a-input>
        </a-form-model-item>

        <a-form-model-item label="Sub Amount" prop="sub_amount">
          <a-input placeholder="Sub Amount." v-model.number="form.response.sub_amount"></a-input>
        </a-form-model-item>

        <a-form-model-item label="Admin Charge" prop="admin_charges">
          <a-input placeholder="Admin Charge." v-model.number="form.response.admin_charges"></a-input>
        </a-form-model-item>

        <a-form-model-item label="Total Bill Amount" prop="total_bill_amount">
          <a-input placeholder="Total Bill Amount." v-model.number="form.response.total_bill_amount"></a-input>
        </a-form-model-item>

        <a-form-model-item label="Total Payment" prop="total_payment">
          <a-input placeholder="Total Payment." v-model.number="form.response.total_payment"></a-input>
        </a-form-model-item>

        <a-form-model-item label="Info" prop="info">
          <a-input placeholder="Info." v-model="form.response.info"></a-input>
        </a-form-model-item>

        <template v-if="item.product.code == 'PLN' || item.product.code == 'PLN-NTL'">
          <a-divider dashed>Bills ({{ form.response.bills.length }})</a-divider>

          <template v-for="(subItem,index) in form.response.bills">
            <a-divider dashed :key="`divider-${index}`" v-if="index > 0"></a-divider>

            <a-form-model-item :label='"Period " + (index+1)' prop="period" :key="`period-${index}`">
              <a-input placeholder="" v-model="form.response.bills[index].period"></a-input>
            </a-form-model-item>

            <a-form-model-item label="Admin Charge" prop="admin_charges" :key="`admin_charges-${index}`">
              <a-input placeholder="" v-model.number="form.response.bills[index].admin_charges"></a-input>
            </a-form-model-item>

            <a-form-model-item label="Amount" prop="amount" :key="`amount-${index}`">
              <a-input placeholder="" v-model.number="form.response.bills[index].amount"></a-input>
            </a-form-model-item>

            <template v-if="item.product.code == 'PLN'">
              <a-form-model-item label="Current Meter Reading 1" prop="current_meter_reading_1" :key="`current_meter_reading_1-${index}`">
                <a-input placeholder="" v-model.number="form.response.bills[index].additional_data.current_meter_reading_1"></a-input>
              </a-form-model-item>

              <a-form-model-item label="Current Meter Reading 2" prop="current_meter_reading_2" :key="`current_meter_reading_2-${index}`">
                <a-input placeholder="" v-model.number="form.response.bills[index].additional_data.current_meter_reading_2"></a-input>
              </a-form-model-item>

              <a-form-model-item label="Current Meter Reading 3" prop="current_meter_reading_3" :key="`current_meter_reading_3-${index}`">
                <a-input placeholder="" v-model.number="form.response.bills[index].additional_data.current_meter_reading_3"></a-input>
              </a-form-model-item>

              <a-form-model-item label="Due Date" prop="due_date" :key="`due_date-${index}`">
                <a-input placeholder="" v-model="form.response.bills[index].additional_data.due_date"></a-input>
              </a-form-model-item>

              <a-form-model-item label="Incentive" prop="incentive" :key="`incentive-${index}`">
                <a-input placeholder="" v-model.number="form.response.bills[index].additional_data.incentive"></a-input>
              </a-form-model-item>

              <a-form-model-item label="Meter Reading Date" prop="meter_reading_date" :key="`meter_reading_date-${index}`">
                <a-input placeholder="" v-model="form.response.bills[index].additional_data.meter_reading_date"></a-input>
              </a-form-model-item>

              <a-form-model-item label="Penalty Fee" prop="penalty_fee" :key="`penalty_fee-${index}`">
                <a-input placeholder="" v-model.number="form.response.bills[index].additional_data.penalty_fee"></a-input>
              </a-form-model-item>

              <a-form-model-item label="Prev Meter Reading 1" prop="prev_meter_reading_1" :key="`prev_meter_reading_1-${index}`">
                <a-input placeholder="" v-model.number="form.response.bills[index].additional_data.prev_meter_reading_1"></a-input>
              </a-form-model-item>

              <a-form-model-item label="Prev Meter Reading 2" prop="prev_meter_reading_2" :key="`prev_meter_reading_2-${index}`">
                <a-input placeholder="" v-model.number="form.response.bills[index].additional_data.prev_meter_reading_2"></a-input>
              </a-form-model-item>

              <a-form-model-item label="Prev Meter Reading 3" prop="prev_meter_reading_3" :key="`prev_meter_reading_3-${index}`">
                <a-input placeholder="" v-model.number="form.response.bills[index].additional_data.prev_meter_reading_3"></a-input>
              </a-form-model-item>

              <a-form-model-item label="VAT" prop="vat" :key="`vat-${index}`">
                <a-input placeholder="" v-model.number="form.response.bills[index].additional_data.vat"></a-input>
              </a-form-model-item>
            </template>

          </template>

          <a-button type="dashed" style="width: 60%" @click="addBill">
            <a-icon type="plus" /> Add bill
          </a-button>
        </template>

        <a-divider dashed>Additional data</a-divider>

        <template v-if="item.product.code == 'PLN'">
          <a-form-model-item label="Bill Status" prop="bill_status">
            <a-input v-model.number="form.response.additional_data.bill_status"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Customer Segmentation" prop="customer_segmentation">
            <a-input v-model="form.response.additional_data.customer_segmentation"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Meter Stand" prop="meter_stand">
            <a-input v-model="form.response.additional_data.meter_stand"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Outstanding Bill" prop="outstanding_bill">
            <a-input v-model.number="form.response.additional_data.outstanding_bill"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Power Consuming Category" prop="power_consuming_category">
            <a-input v-model.number="form.response.additional_data.power_consuming_category"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Power Tariff" prop="power_tariff">
            <a-input v-model="form.response.additional_data.power_tariff"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Text Month" prop="text_month">
            <a-input v-model="form.response.additional_data.text_month"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Total Penalty" prop="total_penalty">
            <a-input v-model.number="form.response.additional_data.total_penalty"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Total VAT" prop="total_vat">
            <a-input v-model.number="form.response.additional_data.total_vat"></a-input>
          </a-form-model-item>
        </template>

        <template v-else-if="item.product.code == 'PLN-NTL'">
          <a-form-model-item label="PLN Reference Number" prop="pln_reference_number">
            <a-input v-model="form.response.additional_data.pln_reference_number"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Registration Date" prop="registration_date">
            <a-input v-model="form.response.additional_data.registration_date"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Registration Number" prop="registration_number">
            <a-input v-model="form.response.additional_data.registration_number"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Transaction Name" prop="transaction_name">
            <a-input v-model="form.response.additional_data.transaction_name"></a-input>
          </a-form-model-item>
        </template>

        <template v-else>
          <a-form-model-item label="Customer Payable Installment" prop="customer_payable_installment">
            <a-input v-model.number="form.response.additional_data.customer_payable_installment"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Customer Segmentation" prop="customer_segmentation">
            <a-input v-model="form.response.additional_data.customer_segmentation"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Power Purchase" prop="power_purchase">
            <a-input v-model.number="form.response.additional_data.power_purchase"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Power Consuming Category" prop="power_consuming_category">
            <a-input v-model.number="form.response.additional_data.power_consuming_category"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Power Tariff" prop="power_tariff">
            <a-input v-model="form.response.additional_data.power_tariff"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Public Lighting Tax" prop="public_lighting_tax">
            <a-input v-model.number="form.response.additional_data.public_lighting_tax"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Purchase KWh" prop="purchase_kwh">
            <a-input v-model="form.response.additional_data.purchase_kwh"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Stamp Duty" prop="stamp_duty">
            <a-input v-model.number="form.response.additional_data.stamp_duty"></a-input>
          </a-form-model-item>

          <a-form-model-item label="Token Number" prop="token_number">
            <a-input v-model="form.response.additional_data.token_number"></a-input>
          </a-form-model-item>

          <a-form-model-item label="VAT" prop="value_added_tax">
            <a-input v-model.number="form.response.additional_data.value_added_tax"></a-input>
          </a-form-model-item>
        </template>

      </template>

      <template v-else>
        <v-jsoneditor v-model="form.response" :plus="true" :options="{ mode: 'code' }" style="margin-top: 8px; height: 350px" />
      </template>

      <a-form-model-item>
        <a-space>
          <a-popconfirm title="Are you sure to edit this transaction?" ok-text="Yes" cancel-text="No" @confirm="submit">
            <a-button type="primary" size="small" icon="save" :loading="submitting">Save</a-button>
          </a-popconfirm>
          <a-button size="small" icon="rollback" @click="reset" :loading="submitting">Reset</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>
